"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPrice$ = exports.FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPrice$outboundSchema = exports.FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPrice$inboundSchema = void 0;
exports.fastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPriceToJSON = fastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPriceToJSON;
exports.fastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPriceFromJSON = fastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPriceFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPrice$inboundSchema = z.object({
    average_listing_price: z.number().int(),
    total_properties: z.number().int(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "average_listing_price": "averageListingPrice",
        "total_properties": "totalProperties",
    });
});
/** @internal */
exports.FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPrice$outboundSchema = z.object({
    averageListingPrice: z.number().int(),
    totalProperties: z.number().int(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        averageListingPrice: "average_listing_price",
        totalProperties: "total_properties",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPrice$;
(function (FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPrice$) {
    /** @deprecated use `FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPrice$inboundSchema` instead. */
    FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPrice$.inboundSchema = exports.FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPrice$inboundSchema;
    /** @deprecated use `FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPrice$outboundSchema` instead. */
    FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPrice$.outboundSchema = exports.FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPrice$outboundSchema;
})(FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPrice$ || (exports.FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPrice$ = FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPrice$ = {}));
function fastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPriceToJSON(fastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPrice) {
    return JSON.stringify(exports.FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPrice$outboundSchema
        .parse(fastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPrice));
}
function fastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPriceFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPrice$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPrice' from JSON`);
}
//# sourceMappingURL=fastapikrakenendpointsstatsmodelslettingsnationalgetaveragelistingpricenationalresponseslistingprice.js.map